import { Routes, RouterModule } from '@angular/router';
import { EmailSenderComponent } from './email-sender.component';

const routes: Routes = [
    {
        path: '',
        component: EmailSenderComponent
    },
];

export const EmailSenderRoutes = RouterModule.forChild(routes);
